import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ChartPlotterComponent } from "./chart-plotter/chart-plotter.component";
import { HighchartsChartModule } from "highcharts-angular";
import { RouterModule, Routes } from "@angular/router";

import { IconsModule } from "@va/core-library/icons";
//import { MatCarouselModule } from "@ngmodule/material-carousel";
import { SharedModule } from "../shared/shared.module";
import { FormsModule } from "@angular/forms";

import { ChartPopupComponent } from "./chart-popup/chart-popup.component";
import { ChartDataTableComponent } from "./chart-data-table/chart-data-table.component";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzCarouselModule } from "ng-zorro-antd/carousel";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";

const chartRoutes: Routes = [{ path: "", component: ChartPlotterComponent }];

@NgModule({
  imports: [RouterModule.forChild(chartRoutes)],
  exports: [RouterModule],
})
export class ChartPlotterRoutingModule {}

@NgModule({
  imports: [
    CommonModule,
    ChartPlotterRoutingModule,
    HighchartsChartModule,
    IconsModule,
    FormsModule,
    //MatCarouselModule.forRoot(),
    SharedModule,
    NzTableModule,
    NzSpinModule,
    NzSkeletonModule,
    NzModalModule,
    NzRadioModule,
    NzSelectModule,
    NzCarouselModule,
    NzCheckboxModule,
    NzToolTipModule,
  ],
  declarations: [
    ChartPlotterComponent,
    ChartPopupComponent,
    ChartDataTableComponent,
  ],
  exports: [ChartPlotterComponent, ChartPopupComponent],
})
export class ChartPlotterModule {}
